export { buildClassMap } from './buildClassMap';
export { getIcon, registerIcons, registerIconAlias, setIconOptions } from './icons';
export { getIconClassName } from './getIconClassName';
//# sourceMappingURL=index.js.map